<header>
  <a class="home-link" routerLink="/" [attr.aria-label]="isCompassHeader() ? 'Compass Listing Concierge' : null" [class.compass-brand]="isCompassHeader()">
    <img alt="logo" class="logo" [height]="logo().height" [ngClass]="brandService.brandCode() === 'CMP' ? 'height-auto' : ''" [src]="logo().src" [width]="logo().width" />
    @if (isCompassHeader()) {
      <span aria-hidden="true" class="compass-divider"></span>
    }
    <h1>{{ brandService.applicationName() }}</h1>
  </a>

  <div class="fx-row fx-gap-sm y-center">
    <lc-notifications-menu />
    <button class="profile-menu-button" lcTestId [matMenuTriggerFor]="profileMenu">
      <bspk-avatar
        showIcon
        size="large"
        [image]="profilePhoto()"
        [name]="fullName()"
      />
      @if (!isMobile()) {
        <span>{{ firstName() }}</span>
        <bspk-icon name="KeyboardArrowDown" />
      }
    </button>

    <mat-menu #profileMenu>
      <div style="width: 280px">
        <div class="fx-column x-center fx-gap-md py-2">
          <bspk-avatar
            showIcon
            size="large"
            [image]="profilePhoto()"
            [name]="fullName()"
          />
          <span bspk-txt="body-large">{{ fullName() }}</span>
        </div>

        <bspk-divider />

        @for (item of menuItems(); track item.name) {
          @if (item.url) {
            <a bspk-list-item style="color: inherit;" [label]="item.name" [routerLink]="item.url">
              <bspk-icon data-leading [name]="item.icon" />
            </a>
          } @else if (item.onClick) {
            <button bspk-list-item [label]="item.name" (click)="item.onClick()">
              <bspk-icon data-leading [name]="item.icon" />
            </button>
          }
        }
      </div>
    </mat-menu>
  </div>
</header>
